export const WarningIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
  >
    <circle cx="12" cy="12" r="10" fill="#facc15" />
    <path
      d="M12 7v5"
      stroke="#000"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    ></path>
    <circle cx="12" cy="16" r="1.5" fill="#000" />
  </svg>
);